import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublishIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Publish",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M19.59 14.89c-.57 0-1.02-.46-1.02-1.02V5.74l-2.05 2.05c-.43.43-1.12.43-1.55 0s-.43-1.12 0-1.55l4-3.94c.08-.09.18-.16.29-.22.27-.13.59-.13.86 0 .12.06.24.14.33.25l3.94 3.92a1 1 0 0 1 .33.78c-.02.6-.5 1.09-1.11 1.11-.3 0-.58-.12-.78-.35l-2.05-2.05v8.09c.02.57-.42 1.04-.98 1.06h-.19ZM10.09 30c-1.88 0-3.4-1.52-3.4-3.4V11.92c0-1.88 1.52-3.4 3.4-3.4h2.84c.53-.01.96.4.98.93v.1c.02.5-.37.93-.87.95H10.1c-.79 0-1.43.64-1.46 1.42V26.6c0 .81.65 1.46 1.46 1.47h11.83c.81 0 1.46-.66 1.46-1.47V13.62c.1-.46.5-.79.97-.8.47-.03.89.3.96.77V26.6c0 1.88-1.52 3.4-3.4 3.4H10.1Zm6.05-13.08h-5.12a.72.72 0 0 1-.8-.63c-.05-.39.23-.75.63-.8h5.29c.39-.05.75.23.8.63.05.39-.23.75-.63.8zm4.87 4.28h-10c-.4 0-.72-.32-.72-.72s.32-.72.72-.72h10c.4 0 .72.32.72.72s-.32.72-.72.72m0 4.2h-10c-.4 0-.72-.32-.72-.72s.32-.72.72-.72h10c.4 0 .72.32.72.72s-.32.72-.72.72"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.32 30.57H8.29c-1.89 0-3.43-1.54-3.43-3.43V6.57c0-1.89 1.54-3.43 3.43-3.43H14a1.14 1.14 0 1 1 0 2.28H8.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h16.04c.63 0 1.14-.51 1.14-1.14V13.42a1.14 1.14 0 1 1 2.28 0v13.71c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.04 14.57c-.63 0-1.14-.51-1.14-1.14V2a1.14 1.14 0 1 1 2.28 0v11.43c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.61 7.71c-.29 0-.58-.11-.81-.33l-3.76-3.76-3.76 3.76c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l4.57-4.57a1.15 1.15 0 0 1 1.62 0l4.57 4.57a1.14 1.14 0 0 1-.81 1.95M22 26H10.57a1.14 1.14 0 1 1 0-2.28H22A1.14 1.14 0 1 1 22 26M22 21.43H10.57a1.14 1.14 0 1 1 0-2.28H22a1.14 1.14 0 1 1 0 2.28M17.43 16.86h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
PublishIcon.displayName = 'PublishIcon';